/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, Fragment } from "react";
import { Modal } from "semantic-ui-react";
import moment from "moment";
import { useAuth } from "../../AuthenticationStore";
import { useInterval } from "../utils/useInterval";
import notificationSVG from "../../assets/images/sidebar/notification.svg";

export const Notifications = () => {
  const { notificationService } = useAuth();
  // const [total, setTotal] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [modalDetail, setModalDetail] = useState(false);
  const [messageDetail, setMessageDetail] = useState({
    largeMessage: "",
    shortMessage: ""
  });

  const getNotifications = async () => {
    if (!notificationService) return;
    const responseNotifications = await notificationService.getNotifications();
    // setTotal(responseNotifications.object.length);
    setNotifications(responseNotifications.object);
  };

  useInterval(getNotifications, 60000);

  useEffect(() => {
    if (!notificationService) return;
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationService]);

  const discardMessage = async notificationId => {
    await notificationService.readNotification(notificationId);
    // reload notifications
    getNotifications();
  };

  return (
    <Fragment>
      <li className="nav-item dropdown">
        <a
          className="nav-link dropdown-toggle d-flex align-items-center justify-content-center"
          id="notificationDropdown"
          href="#"
          data-toggle="dropdown"
        >
          <img src={notificationSVG} alt="" className="nav-icon-title" />
          {notifications.length > 0 ? (
            <span className="count-circle"></span>
          ) : null}
        </a>
        <div
          className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
          aria-labelledby="notificationDropdown"
        >
          <p className="mb-0 font-weight-normal float-left dropdown-header">
            {notifications.length <= 0 ? "No hay" : ""} Notificaciones
          </p>
          {notifications.map((item, key) => (
            <a
              key={key}
              onClick={() => {
                if (!item.largeMessage) return;
                setMessageDetail({
                  largeMessage: item.largeMessage,
                  shortMessage: item.shortMessage
                });
                setModalDetail(true);
              }}
              className="dropdown-item preview-item"
            >
              <div className="preview-thumbnail">
                <div className="preview-icon bg-success">
                  <i className="mdi mdi-information mx-0"></i>
                </div>
              </div>
              <div className="preview-item-content">
                <h6 className="preview-subject font-weight-normal">
                  {item.shortMessage}
                </h6>
                <p className="font-weight-light small-text mb-0 text-muted">
                  {moment(item.notificationDate).format("YYYY-MM-DD HH:mm")}
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    onClick={() => discardMessage(item.notificationId)}
                  >
                    <i class="mdi mdi-delete"></i>
                  </button>
                </p>
              </div>
            </a>
          ))}
        </div>
      </li>
      <Modal
        size="tiny"
        open={modalDetail}
        onClose={() => setModalDetail(false)}
      >
        <Modal.Header>{messageDetail.shortMessage}</Modal.Header>
        <Modal.Content>
          <p>{messageDetail.largeMessage}</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="btn btn-primary btn-icon-text"
            onClick={() => setModalDetail(false)}
          >
            <i className="mdi mdi-check"></i>
            Ok
          </button>
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
};
